export const en = {
    forbidden_title: 'Access denied',
    not_found_title: 'Page not found',
    forbidden_description: 'It seems you don\'t have access to this page. Try updating the page or come back later',
    not_found_description: 'You may have tried to upload a non-existent or deleted page. Go back or contact support',
};
